import { NgModule } from '@angular/core';
import { RouterModule, Routes, PreloadAllModules } from '@angular/router';
import { ErrorComponent } from './components/error/error.component';
import { DownloadpdfThankyouComponent } from './components/urlmodal/downloadpdf-thankyou/downloadpdf-thankyou.component';
import { ThankyoumodalComponent } from './components/urlmodal/thankyoumodal/thankyoumodal.component';
import { CreateemailthankyouComponent } from './components/urlmodal/createemailthankyou/createemailthankyou.component';
import { OrganisationerrorComponent } from './components/urlmodal/organisationerror/organisationerror.component';
import { SigninComponent } from './pages/sign-in/sign-in.component';
import { RegisterComponent } from './pages/register/register.component';
import { FlexibleAuthGuard } from './services/FlexibleAuthGuard';

const routes: Routes = [
  {
    path: 'login',
    canActivate: [FlexibleAuthGuard],
    data: { redirectIfLoggedIn: '/dashboard' },
    component: SigninComponent,
  },
  {
    path: 'register',
    canActivate: [FlexibleAuthGuard],
    data: { redirectIfLoggedIn: '/dashboard' },
    component: RegisterComponent
  },
  {
    path: 'dashboard',
    canActivate: [FlexibleAuthGuard],
    data: { redirectIfNotLoggedIn: '/login' },
    loadChildren: () => import('./pages/dashboard/dashboard.module').then((m) => m.DashboardModule),
  },
  {
    path: 'thankyou',
    component: ThankyoumodalComponent,
    outlet: 'modal'
  },
  {
    path: 'downloadthankyou',
    component: DownloadpdfThankyouComponent,
    outlet: 'modal'
  },
  {
    path: 'emailthankyou',
    component: CreateemailthankyouComponent,
    outlet: 'modal'
  },
  {
    path: 'organizationerror',
    component: OrganisationerrorComponent,
    outlet: 'modal',
  },
  {
    path: 'ConnectionLost',
    component: ErrorComponent,
    data: { errorType: 'Connection Lost' },
  },
  {
    path: 'instant-quote',
    loadComponent: () =>
      import('./shared/components/instant-quote/instant-quote.component')
        .then(c => c.InstantQuoteComponent)
  },
  {
    path: 'tracking',
    loadComponent: () =>
      import('./shared/components/public-tracking/public-tracking.component')
        .then(c => c.PublicTrackingComponent)
  },
  {
    path: 'openapp',
    loadComponent: () =>
      import('./pages/mobile-app/open-app.component').then(m => m.OpenAppComponent)
  },
  {
    path: 'join-organization',
    loadComponent: () =>
      import('./pages/join-organization/join-organization.component')
        .then(c => c.JoinOrganizationComponent)
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: (redirectData) => {
      const params = redirectData?.queryParams;
      if (params && Object.keys(params).length > 0) {
        const query = new URLSearchParams(params).toString();
        return `/dashboard/live-vehicles-availability?${query}`;
      }
      return '/dashboard/live-vehicles-availability';
    }
  },
  { path: '**', component: ErrorComponent },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      initialNavigation: 'enabledBlocking',     // For SSR ✔️
      scrollPositionRestoration: 'enabled',     // UX-friendly ✔️
      onSameUrlNavigation: 'ignore',            // Prevent unnecessary reloads ✔️
      preloadingStrategy: PreloadAllModules,    // ✅ Improve perceived load speed
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule { }
